module.exports = __webpack_public_path__ + "static/media/avatars_male_29.eea22572.png";